let UTILS = require("../libs/utils.js");
var v7760;
var v7761;
module.exports = {
  id: "sdm",
  name: "Squad Deathmatch",
  endStats: ["sid", "name", "score", "kills", "deaths", "assists", "reward"],
  alias: "sdm",
  teams: true,
  multiTeam: 4
};